import { Button, message, Select, Tabs, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useMutation, useQuery } from "@tanstack/react-query";
import DpdBucket from "./Component/DpdBucket";
import FirstvsRepeat from "./Component/FirstvsRepeat";
import GenderAnalytics from "./Component/GenderAnalysis";
import PricipalPaid from "./Component/PrincipalPaid";
import QuartileBucket from "./Component/QuartileBucket";
import { FETCH_SAMPLE_PREINTERVENTION, UPLOAD_PREINTERVENTION_EXCEL } from "../../../constants/endpoints";
import { getPreIntSamplePhonebook } from "../../../services/adminController";
import { fetchAnalysisData } from "../../../services/adminController";
import axios from "axios";
import { useState } from "react";
import { useParams } from "react-router-dom";

const PreIntervention = () => {
  const [status, setStatus] = useState("ALL"); // default filter
  const [stage] = useState("STAGE_1");
  const data = useParams();
  const clientId = data?.lenderId

  // ✅ Fetch sample Excel
  const { data: sampleData, refetch, isFetching } = useQuery({
    queryKey: ["samplePreIntervention"],
    queryFn: getPreIntSamplePhonebook,
    enabled: false,
  });

  // ✅ Upload Excel mutation
  const uploadPreInterventionExcel = async (file: File) => {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(`${UPLOAD_PREINTERVENTION_EXCEL}/?clientId=${clientId}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  };

  const { mutate: uploadExcel, isPending: isUploading } = useMutation({
    mutationFn: uploadPreInterventionExcel,
    onSuccess: () => message.success("File uploaded successfully!"),
    onError: () => message.error("Upload failed. Please try again."),
  });

  const uploadProps = {
    accept: ".xlsx,.xls",
    showUploadList: false,
    beforeUpload: (file: File) => {
      uploadExcel(file);
      return false;
    },
  };

  // ✅ Fetch analytics data
  const { data: analysisData, isLoading, refetch: refetchAnalysis } = useQuery({
    queryKey: ["analysisData", { clientId, stage, status }],
    queryFn: fetchAnalysisData,
  });


  const handleFilterChange = (value: string) => {
    setStatus(value);
  };

  const handleDownloadSample = async () => {
    try {
      const res = await refetch();
      const fileUrl = res.data?.data;

      if (fileUrl) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "Sample_excel_template.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("Sample file downloaded successfully.");
      } else {
        message.error("Failed to fetch download link.");
      }
    } catch (err) {
      message.error("Download failed.");
    }
  };
  const items = [
    { label: "DPD Bucket", key: "1", children: <DpdBucket data={analysisData?.dpdBuckets || []} loading={isLoading} /> },
{
  label: "Principal Paid",
  key: "2",
  children: (
    <PricipalPaid
      data={
        [...(analysisData?.principalPaidBuckets || [])].sort((a, b) => {
          const startA = parseInt(a.bucketName.split(/[–-]/)[0]);
          const startB = parseInt(b.bucketName.split(/[–-]/)[0]);
          return startA - startB;
        })
      }
      loading={isLoading}
    />
  ),
},

    {
  label: "Gender Analysis",
  key: "3",
  children: (
    <GenderAnalytics
      data={[...(analysisData?.genderStats || [])].reverse()}
      loading={isLoading}
    />
  ),
},   
    { label: "First Vs Repeat", key: "4", children: <FirstvsRepeat data={analysisData?.borrowerTypeStats || []} loading={isLoading} /> },
    { label: "Quartile Buckets", key: "5", children: <QuartileBucket data={analysisData?.quartileBuckets || []} loading={isLoading} /> },
  ];

  return (
    <div className="mt-1">
      <div className="flex justify-end items-center gap-3 mb-4">
        <Button size="small" type="link" onClick={handleDownloadSample} loading={isFetching}>
          Download Sample
        </Button>
        <Upload {...uploadProps}>
          <Button type="primary" icon={<UploadOutlined />} loading={isUploading}>
            Upload Excel
          </Button>
        </Upload>

        <Select
          defaultValue="All"
          style={{ width: 120 }}
          onChange={handleFilterChange}
          className="ml-2"
          options={[
            { value: "ALL", label: "All" },
            { value: "NEW", label: "New Case" },
            { value: "RETAINED", label: "Old Case" },
          ]}
        />
      </div>
      <Tabs items={items} />
    </div>
  );
};

export default PreIntervention;
